export default __webpack_public_path__ + "static/media/indicator_carousel1.6cc14c87.svg";